import { render, staticRenderFns } from "./MultiselectCustom.vue?vue&type=template&id=34999300&scoped=true"
import script from "./MultiselectCustom.vue?vue&type=script&setup=true&lang=js"
export * from "./MultiselectCustom.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MultiselectCustom.vue?vue&type=style&index=0&id=34999300&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34999300",
  null
  
)

export default component.exports